<template>
    <span class="highlight">
        <template v-for="(result, index) in highlights">
            <template v-if="result.match">
                <strong :key="index">{{ result.text }}</strong>
            </template>
            <template v-else>{{ result.text }}</template>
        </template>
    </span>
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
    name: "Highlight",
    props: {
        search: {
            type: String,
            default: ""
        },
        text: {
            type: String,
            default: ""
        }
    },
    setup(props) {
        const highlights = computed(() => {
            const results = []
            if (props.search && props.search.length > 0) {
                const regexp = new RegExp(props.search, "ig")

                let start = 0
                for (let match of props.text.matchAll(regexp)) {
                    results.push({
                        text: props.text.substring(start, match.index),
                        match: false
                    })
                    start = match.index
                    results.push({
                        text: props.text.substr(start, props.search.length),
                        match: true
                    })
                    start += props.search.length
                }

                if(start < props.text.length)
                    results.push({ text: props.text.substring(start), match: false})
            }

            if (results.length === 0) {
                results.push({
                    text: props.text,
                    match: false
                })
            }

            return results
        })

        return {
            highlights
        };
    }
}
</script>
